import ErrorToken from "views/pages/error/component/Token";

export default function ContentError({ reduxAuth }) {
    return <ErrorToken reduxAuth={reduxAuth}></ErrorToken>;
}